import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import emitter from './utils/create_emitter';
import router from './router';
import './assets/css/app.css';
import i18n from './locale/i18n';

const app = createApp(App);
app.config.globalProperties.emitter = emitter;
app.use(i18n);
app.use(router);
app.use(createPinia());
app.component('VueDatePicker', VueDatePicker);

app.mount('#app');
